
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      // change progress bar with the navbar height change;
      const bar = document.querySelector( '.progress-container' );
      const checkBar = () => {
        if ( window.pageYOffset > 25 ) {
          bar.classList.add( 'active' );
        } else if ( window.pageYOffset <= 25 ) {
          bar.classList.remove( 'active' );
        }
      };
      checkBar();
      window.addEventListener( 'scroll', checkBar );

      // print button
      $( '.print-article' ).on( 'click', function() {
        $( '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore), .js-animate-up' ).each( function() {
          $( this ).removeClass( '.js-fade' );
        } );
        window.print();
      } );

      // progress bar on scroll
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        gsap.to( '.progress-bar', {
          scrollTrigger: {
            trigger: '.article-page__article',
            scrub: true,
            start: 'top top',
            endTrigger: '.article-page__article',
            end: 'bottom center',
          },
          width: '100%',
          transformOrigin: 'left center',
          ease: 'none',
        } );
      }

      // sidebar accordion at mobile
      $( '.article-accordion__item-title' ).click( function() {
        if ( $( this ).closest( '.article-accordion__item' ).hasClass( 'is-open' ) ) {
          $( this ).closest( '.article-accordion__item' ).find( '.article-accordion__item-content' ).slideUp();
          $( this ).closest( '.article-accordion__item' ).removeClass( 'is-open' );
          $( this ).closest( '.article-accordion__item .accordion-trigger' ).attr( 'aria-expanded', false );
        } else {
          $( '.article-accordion__item.is-open .article-accordion__item-content' ).slideUp();
          $( '.article-accordion__item' ).removeClass( 'is-open' ).not( $( this ).closest( '.article-accordion__item' ) ).find( '.accordion-trigger' ).attr( 'aria-expanded', false );
          $( this ).closest( '.article-accordion__item' ).find( '.article-accordion__item-content' ).slideDown();
          $( this ).closest( '.article-accordion__item' ).find( '.accordion-trigger' ).attr( 'aria-expanded', true );
          $( this ).closest( '.article-accordion__item' ).addClass( 'is-open' );
        }
      } );

      // udpate accordion on media change
      $( document ).on( 'updateMediaQuery', ( event ) => {
        $( '.article-accordion__item-content' ).each( function( index ) {
          $( this ).css( 'display', '' );
        } );

        $( '.article-accordion__item' ).each( function() {
          $( this ).removeClass( 'is-open' );
        } );
      } );
    },
    finalize: function() {

    },
  };
  app.registerComponent( 'article-page', COMPONENT );
} )( app );
